import React from "react";
import AddIcon from "@mui/icons-material/Add";
import { Button } from "@mui/material";

import closeimg from "../../images/close-window.png";
import fileimg from "../../images/file.png";
import ActivityIndicator from "../CommonUtils/ActivityIndicator";

import "./ConversationStyleSheet.css";

function PreviewAttachmentFiles(props) {
  let attachemntFiles = props.files || [];
  return (
    <>
      <div
        className={localStorage.getItem("openInFullScreen") ? "s360-preview-message-container-fs" : "s360-preview-message-container"}>
        {attachemntFiles.map((file) => {
          let fileURL = URL.createObjectURL(file);
          let isAudioFile = file.type.toLowerCase().indexOf("audio/") !== -1;
          let isVideoFile = file.type.toLowerCase().indexOf("video/") !== -1;
          let isImageFile = file.type.toLowerCase().indexOf("image/") !== -1 && file.type.toLowerCase() !== "image/tiff";
          let isOtherFile = file.type.toLowerCase() === "";

          if (isAudioFile) {
            return (
              <div
                key={fileURL}
                className="oneAttachFile"
                style={{
                  marginLeft: "12px",
                  height: "9rem",
                  width: "fit-content",
                  display: "flex",
                  flexDirection: "row-reverse",
                  justifyContent: "end",
                  alignItems: "flex-start",
                  padding: "10px",
                  background: "#ffffff7d",
                  borderRadius: "5px",
                }}
              >
                <div
                  className="s360-preview-close"
                  onClick={() => props?.onRemovePreviewFile && props.onRemovePreviewFile(file)}
                >
                  {" "}
                  <img
                    className="s360-preview-box-close-image"
                    objectFit="contain"
                    width="25px"
                    src={closeimg}
                    alt="close"
                  />{" "}
                </div>
                <figure
                  style={{
                    minWidth: "130px",
                    width: "100%",
                    height: "80px",
                    display: "flex",
                  }}
                >
                  <audio
                    style={{
                      minWidth: "130px",
                      width: "100%",
                      alignSelf: "center",
                      paddingLeft: "10px",
                      paddingRight: "10px",
                      background: 'none'
                    }}
                    controls
                    src={fileURL}
                  >
                    {" "}
                                        Your browser does not support the <code>audio</code>{" "}
                                        element.
                  </audio>
                </figure>
              </div>
            );
          } else if (isVideoFile) {
            return (
              <div
                key={fileURL}
                style={{
                  marginLeft: "12px",
                  height: "9rem",
                  width: "fit-content",
                  display: "flex",
                  flexDirection: "row-reverse",
                  justifyContent: "end",
                  alignItems: "flex-start",
                  padding: "10px",
                  background: "#ffffff7d",
                  borderRadius: "5px",
                }}
                className="oneAttachFile"
              >
                <div
                  className="s360-preview-close"
                  onClick={() => props.onRemovePreviewFile(file)}
                >
                  {" "}
                  <img
                    className="s360-preview-box-close-image"
                    objectFit="contain"
                    width="25px"
                    src={closeimg}
                    alt="close"
                  />{" "}
                </div>
                <video
                  controls
                  width="180"
                  height="74px"
                  style={{
                    height: "74px",
                    borderRadius: "5px",
                  }}
                >
                  <source src={fileURL} type="video/mp4"/>
                                    Sorry, your
                                    browser doesn't support embedded videos.
                </video>
              </div>
            );
          } else if (isImageFile) {
            return (
              <div
                key={fileURL}
                className="oneAttachFile"
                style={{
                  marginLeft: "12px",
                  height: "9rem",
                  width: "fit-content",
                  display: "flex",
                  flexDirection: "row-reverse",
                  justifyContent: "end",
                  alignItems: "flex-start",
                  padding: "10px",
                  background: "#ffffff7d",
                  borderRadius: "5px",
                }}
              >
                <div
                  className="s360-preview-close"
                  onClick={() => props.onRemovePreviewFile(file)}
                >
                  {" "}
                  <img
                    className="s360-preview-box-close-image"
                    objectFit="contain"
                    width="25px"
                    src={closeimg}
                    alt="close"
                  />{" "}
                </div>
                <img width="70px" height="70px" src={fileURL} alt=""/>
              </div>
            );
          } else if (isOtherFile) {
            return (
              <div
                key={fileURL}
                className="oneAttachFile"
                style={{
                  marginLeft: "12px",
                  height: "9rem",
                  width: "fit-content",
                  display: "flex",
                  flexDirection: "row-reverse",
                  justifyContent: "end",
                  alignItems: "flex-start",
                  padding: "10px",
                  background: "#ffffff7d",
                  borderRadius: "5px",
                }}
              >
                <div
                  className="s360-preview-close"
                  onClick={() => props.onRemovePreviewFile(file)}
                >
                  {" "}
                  <img
                    className="s360-preview-box-close-image"
                    objectFit="contain"
                    width="25px"
                    src={closeimg}
                    alt="close"
                  />{" "}
                </div>
                <a target="_blank" href={fileURL} rel="noreferrer" download>
                  <img
                    width="70"
                    height="70"
                    title={fileURL}
                    src={fileimg}
                    alt="close"
                  ></img>
                </a>
              </div>
            );
          } else {
            return (
              <div
                key={fileURL}
                className="oneAttachFile"
                style={{
                  marginLeft: "12px",
                  height: "9rem",
                  width: "fit-content",
                  display: "flex",
                  flexDirection: "row-reverse",
                  justifyContent: "end",
                  alignItems: "flex-start",
                  padding: "10px",
                  background: "#ffffff7d",
                  borderRadius: "5px",
                }}
              >
                <div
                  className="s360-preview-close"
                  onClick={() => props.onRemovePreviewFile(file)}
                >
                  {" "}
                  <img
                    className="s360-preview-box-close-image"
                    objectFit="contain"
                    width="25px"
                    src={closeimg}
                    alt="close"
                  />{" "}
                </div>
                <a target="_blank" href={fileURL} rel="noreferrer" download>
                  <img
                    width="70"
                    height="70"
                    title={fileURL}
                    src={fileimg}
                    alt="close"
                  ></img>
                </a>
              </div>
            );
          }
        })}

        <input
          style={{ display: "none" }}
          id="raised-button-file"
          multiple
          type="file"
          accept="image/*, video/*, audio/*, .doc,.docx, .pdf, .xls, .txt, .ppt, .xlsx, .csv,.ogg, .pdf, .png, .ppt, .pptx, .rar, .tif, .tiff, .wav, .xls, .xlsx, .xps, .zip"
          onChange={(e) => props?.onAddPreviewFile && props.onAddPreviewFile(e)}
        />
        <label htmlFor="raised-button-file">
          <Button variant="raised" component="span">
            <AddIcon
              style={{
                width: "70px",
                height: "70px",
                marginLeft: "10px",
                borderRadius: "4px",
                background: "lightblue",
                cursor: "pointer",
                position: "absolute",
                left: "0px",
                marginTop: "10px",
              }}
            />
          </Button>
        </label>

        {!!props?.isLoading && <ActivityIndicator/>}
      </div>
    </>
  );
}

export default PreviewAttachmentFiles;
